const originHeaders = [
  {text: 'Mã hồ sơ', value: 'code'},
  {text: 'Cơ sở', value: 'department'},
  {text: 'Họ và tên', value: 'name'},
  {text: 'Ngày sinh', value: 'dob'},
  {text: 'Điểm Kỹ năng Tư duy', value: 'examMathMark'},
  {text: 'Điểm Kỹ năng Ngôn ngữ', value: 'examLanguage'},
  {text: 'Điểm ưu tiên', value: 'priorityMark'},
  {text: 'Tổng điểm', value: 'examTotal'},
  {text: 'NV1', value: 'expectation1'},
  {text: 'NV2', value: 'expectation2'},
  {text: 'NV3', value: 'expectation3'},
  {text: 'Kết quả trúng tuyển', value: 'examPass'}
]

const {get} = require('lodash')

function getPassExamText(item = {}) {
  const passExamType = get(item, 'ltvExamResult.passExamType')
  switch (passExamType) {
    case 'pass':
      return 'Đã trúng tuyển'
    case 'fail':
      return 'Không trúng tuyển'
    case 'reserve':
      return 'Dự khuyết'
    default:
      return '---'
  }
}

function getShortClassName(item = {}, nth = 1) {
  const clazz = get(item, `expectation${nth}.clazz`)
  if (!clazz) return '---'
  switch (clazz) {
    case 'Lớp Chất lượng cao (CLC)':
      return '(CLC)'
    case 'Lớp chọn Chất lượng cao c(CLC)':
      return 'c(CLC)'
    case 'Lớp Năng khiếu Anh (NKA)':
      return '(NKA)'
    case 'Lớp Năng khiếu Toán (NKT)':
      return '(NKT)'
    default:
      return '---'
  }
}

export {originHeaders, getPassExamText, getShortClassName}
